// extracted by mini-css-extract-plugin
module.exports = {"root":"VIP_ClientDiscountActions__root","disabled":"VIP_ClientDiscountActions__disabled","iconButton":"VIP_ClientDiscountActions__iconButton"};